import { GET_ALL_PROCUREMENTS } from '../types';

export default function procurements(state = {}, action) {
	switch (action.type) {
		case GET_ALL_PROCUREMENTS:
			return action.payload;
		default:
			return state;
	}
}
